import React, { InputHTMLAttributes } from 'react';

import TopLabel from '@/components/common/TopLabel/TopLabel';
import ValidationAlert from '@/components/common/ValidationAlert/ValidationAlert';
import { IModalFormProps } from '../ModalFormProps.interface';
import Input from '@/components/common/Input/Input';

type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'validationMessage'>;
interface IModalFormTextInputProps extends IModalFormProps, InputProps {
  id: string;
}

export default function ModalFormTextInput({
  id,
  className,
  labelTitle,
  requiredIcon = false,
  validationMessage,
  isFloatingValidation = false,
  ...restProps
}: IModalFormTextInputProps) {
  return (
    <div className={className}>
      {labelTitle && (
        <TopLabel
          id={id}
          label={labelTitle}
          required={requiredIcon}
        />
      )}

      <Input id={id} {...restProps}
      />

      {validationMessage && (
        <ValidationAlert
          isFloating={isFloatingValidation}
          type="danger"
        >
          {validationMessage}
        </ValidationAlert>
      )}
    </div>
  );
}
